function stripCommentsAndBoilerplate(content, fileName) {
  if (!content) {
    return "";
  }

  const ext = (fileName || "").split(".").pop().toLowerCase();
  let stripped = content;

  if (ext === "py") {
    stripped = stripped.replace(/#.*$/gm, "");
  } else if (ext === "html") {
    stripped = stripped.replace(/<!--[\s\S]*?-->/g, "");
  } else if (ext === "css") {
    stripped = stripped.replace(/\/\*[\s\S]*?\*\//g, "");
  } else if (ext === "js") {
    stripped = stripped.replace(/\/\*[\s\S]*?\*\//g, "").replace(/\/\/.*$/gm, "");
  } else if (ext === "ino" || ext === "cpp" || ext === "h" || ext === "c") {
    stripped = stripped
      .replace(/\/\*[\s\S]*?\*\//g, "")
      .replace(/\/\/.*$/gm, "")
      .replace(/void\s+setup\s*\(\s*\)\s*\{\s*\}/g, "")
      .replace(/void\s+loop\s*\(\s*\)\s*\{\s*\}/g, "");
  }

  return stripped.trim();
}

export function hasRealCode(content, fileName) {
  return stripCommentsAndBoilerplate(content, fileName).length > 0;
}

export function buildFileContentMap(fileTree) {
  const map = {};

  function walk(nodes) {
    if (!nodes) {
      return;
    }
    nodes.forEach((node) => {
      if (node.isFile) {
        map[node.id] = hasRealCode(node.fileContent, node.fileName);
      } else {
        walk(node.children);
      }
    });
  }

  walk(fileTree);
  return map;
}

export function isProjectEmptyFromMap(fileContentMap) {
  return !Object.values(fileContentMap).some(Boolean);
}
